import {gql} from '@apollo/client'

// A public post on X, for the photos and videos that can be added from it. Asked again for every
// link, since a post can be deleted or hidden between one look and the next.
export const X_POST = gql`
  query XPost($link: String!) {
    xPost(link: $link) {
      id
      authorName
      handle
      text
      postedAt
      media {
        kind
        url
        previewUrl
        filename
        width
        height
        durationMs
      }
    }
  }
`
